import { useSnackbar } from "notistack5";
import { useRef, useState } from "react";
import {  useNavigate } from "react-router-dom";
// material
import {  Box , MenuItem } from "@material-ui/core";
// routes
import { PATH_DASHBOARD } from "../../routes/paths";
// hooks
import useAuth from "../../hooks/useAuth";
import useIsMountedRef from "../../hooks/useIsMountedRef";
// components
import { MIconButton } from "../../components/@material-extend";
import Cookies from "universal-cookie";
import MenuPopover from "../../components/MenuPopover";
import { decryptData } from "src/utils/decryptcookie";
import SvgIconStyle from "src/components/SvgIconStyle";
import AgentMarkupDialog from "src/components/dialog/AgentMarkupDialog";
import { logoutUser } from "src/Api/auths.js"
 
// ----------------------------------------------------------------------
const ICONS = {
  Logout : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#ee4b2b" fill-rule="evenodd" d="M6 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm10.293 5.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L18.586 13H10a1 1 0 1 1 0-2h8.586l-2.293-2.293a1 1 0 0 1 0-1.414" clip-rule="evenodd"/></svg>,

  profile : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#ee4b2b" fill-rule="evenodd" d="M14.447 1.106a1 1 0 0 1 .447 1.341L14.118 4H18a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h3.882l-.776-1.553a1 1 0 0 1 1.788-.894L12 3.763l1.106-2.21a1 1 0 0 1 1.341-.447" class="duoicon-secondary-layer" opacity="0.3"/><path fill="#ee4b2b" fill-rule="evenodd" d="M12 9c-1.54 0-2.502 1.667-1.732 3c.357.619 1.017 1 1.732 1c1.54 0 2.502-1.667 1.732-3A2 2 0 0 0 12 9m1.5 5h-3a2.5 2.5 0 0 0-2.495 2.336L8 16.5v.5a1 1 0 0 0 1.993.117L10 17v-.5a.5.5 0 0 1 .41-.492L10.5 16h3a.5.5 0 0 1 .492.41l.008.09v.5a1 1 0 0 0 1.993.117L16 17v-.5a2.5 2.5 0 0 0-2.336-2.495z" class="duoicon-primary-layer"/></svg>,
  markup : <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><g fill="none" stroke="#ee4b2b" stroke-width="1.5"><path d="M17.414 10.414C18 9.828 18 8.886 18 7s0-2.828-.586-3.414m0 6.828C16.828 11 15.886 11 14 11h-4c-1.886 0-2.828 0-3.414-.586m10.828 0Zm0-6.828C16.828 3 15.886 3 14 3h-4c-1.886 0-2.828 0-3.414.586m10.828 0Zm-10.828 0C6 4.172 6 5.114 6 7s0 2.828.586 3.414m0-6.828Zm0 6.828Z"/><path d="M13 7a1 1 0 1 1-2 0a1 1 0 0 1 2 0Z" opacity="0.5"/><path stroke-linecap="round" d="M18 6a3 3 0 0 1-3-3m3 5a3 3 0 0 0-3 3M6 6a3 3 0 0 0 3-3M6 8a3 3 0 0 1 3 3M4 21.388h2.26c1.01 0 2.033.106 3.016.308a14.9 14.9 0 0 0 5.33.118c.868-.14 1.72-.355 2.492-.727c.696-.337 1.549-.81 2.122-1.341c.572-.53 1.168-1.397 1.59-2.075c.364-.582.188-1.295-.386-1.728a1.89 1.89 0 0 0-2.22 0l-1.807 1.365c-.7.53-1.465 1.017-2.376 1.162q-.165.026-.345.047m0 0l-.11.012m.11-.012a1 1 0 0 0 .427-.24a1.49 1.49 0 0 0 .126-2.134a1.9 1.9 0 0 0-.45-.367c-2.797-1.669-7.15-.398-9.779 1.467m9.676 1.274a.5.5 0 0 1-.11.012m0 0a9.3 9.3 0 0 1-1.814.004" opacity="0.5"/></g></svg>

}

const MENU_OPTIONS = [
  {
    label: "Profile",
    // icon: homeFill,
    icon: ICONS.profile,
    linkTo: "/pofile",
  },
  {
    label: "Add Markup",
    // icon: personFill,
    icon: ICONS.markup,
    linkTo: PATH_DASHBOARD.user.profile,
  },
  {
    label: "Log out",
    icon: ICONS.Logout,
    linkTo: PATH_DASHBOARD.user.account,
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const cookies = new Cookies();
  let userInfo = decryptData("_b60-g6fr_plus");
  const isMountedRef = useIsMountedRef();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [openBookingModal, setOpenBookingModal] = useState(false);
  const role = userInfo?.role || "";

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      cookies.remove("_b60-g6fr_plus", { path: "/" });
      navigate("/", { replace: true });
      await logout();
      await logoutUser(localStorage.getItem("deviceId"))
      localStorage.removeItem("deviceId");
      if (isMountedRef.current) {
        handleClose();
      }
    } catch (error) {  
    }
  };

  const onClickMenu =(idx) =>{
    switch(idx){
      case 0 :
        // open
        navigate("user-profile")
        break 
      case 1 :
        setOpenBookingModal(true);
        break  
      case 2 :
        handleLogout()
        break 
        default : break 
    }
    setOpen(false);
  }

  return (
    <>
      <MIconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              // bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
            },
          }),
        }}
      >
        <Box
      sx={{
        position: 'relative',
        width: 50,
        height: 50,
        borderRadius: '50%',
        overflow: 'hidden',
        // backgroundColor: (theme) => theme.palette.primary,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}
    >
      <SvgIconStyle
        src={`/static/icons/navbar/ic-agent.svg`}
        sx={{ 
          width: '60%', 
          height: '60%',
          color: (theme) => theme.palette.primary.main
        }}
      />
    </Box>
      </MIconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
       {/* <div className="py-2 h-[20px] bg-[#ee2b2b]">

       </div> */}


        {MENU_OPTIONS.map((option,idx) => { 
          if(role != "agent" && (idx == 1 || idx == 0)) return null
          return(
          <MenuItem
            key={option.label}
            onClick={()=>onClickMenu(idx)}
            className="flex items-center h-[48px] gap-2"
          >

            {option.icon}
            <span className="text-sm font-semibold">{option.label}</span>
           
          </MenuItem>
        )})}

        {/* <Box
          sx={{
            p: 2,
            pt: 1.5,
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Button
            fullWidth
            color="inherit"
            variant="outlined"
            onClick={handleAddMarkupPopup}
            className={role !== "agent" ? "d-none" : ""}
          >
            Add Markup
          </Button>
          <Button
            fullWidth
            color="inherit"
            variant="outlined"
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Box> */}
      </MenuPopover>
      <AgentMarkupDialog
        setOpenBookingModal={setOpenBookingModal}
        openBookingModal={openBookingModal}
      ></AgentMarkupDialog>
    </>
  );
}
